import { useImmutableContext, useImmutableContextProvider } from "@devowl-wp/react-utils";
const FORM_SERVICE_CONTEXT_SYMBOL = Symbol();
const useFormService = ()=>useImmutableContext(FORM_SERVICE_CONTEXT_SYMBOL);
const useFormServiceProvider = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return useImmutableContextProvider(FORM_SERVICE_CONTEXT_SYMBOL, ...args);
};
export { useFormService, useFormServiceProvider };
